import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateVehicleInput,
    DeleteVehicleTypeInput,
    UpdateVehicleTypeInput,
    VehicleType
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class VehicleTypeService {
    private amplifyClient = generateClient();
    constructor() {}

    async getVehicleType(id: string): Promise<VehicleType> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getVehicleType,
                    variables: {
                        id
                    }
                })
            ).data.getVehicleType;
            if (data) return data as VehicleType;
        } catch (error) {
            console.error('Error Vehicle:', error);
            return null;
        }
    }

    async listVehicleTypes(): Promise<VehicleType[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listVehicleTypes
                })
            ).data.listVehicleTypes.items;
            if (data) return data as VehicleType[];
        } catch (error) {
            console.error('Error finding VehicleType:', error);
            return null;
        }
    }

    async listAllVehicleTypes(pageLimit: number = 100): Promise<VehicleType[]> {
        const types: VehicleType[] = [];
        let nextToken: string | null = null;

        try {
            do {
                const response = (
                    await this.amplifyClient.graphql({
                        query: queries.listVehicleTypes,
                        variables: {
                            limit: pageLimit,
                            nextToken
                        }
                    })
                ).data.listVehicleTypes;
                types.push(...((response?.items ?? []) as VehicleType[]));
                nextToken = response?.nextToken ?? null;
            } while (nextToken !== null);
            return types;
        } catch (error) {
            console.error('Error finding VehicleType:', error);
            return [];
        }
    }

    async vehicleTypesByPopMaterialId(
        popMaterialId: string,
        limit: number = 100
    ): Promise<VehicleType[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.VehicleTypesByPopMaterialId,
                    variables: { popMaterialId, limit }
                })
            ).data.VehicleTypesByPopMaterialId.items;
            if (data) return data as VehicleType[];
        } catch (error) {
            console.error('Error finding VehicleType:', error);
            return null;
        }
    }

    async vehicleTypesByPopMaterialIds(): Promise<VehicleType[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.VehicleTypesByPopMaterialId
                })
            ).data.VehicleTypesByPopMaterialId.items;
            if (data) return data as VehicleType[];
        } catch (error) {
            console.error('Error finding VehicleType:', error);
            return null;
        }
    }

    async createVehicleType(input: CreateVehicleInput): Promise<VehicleType> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.createVehicleType,
                    variables: {
                        input
                    }
                })
            ).data.createVehicleType;
            if (date) return date as VehicleType;
        } catch (error) {
            console.error('Error creating VehicleType:', error);
            return null;
        }
    }

    async updateVehicleType(
        input: UpdateVehicleTypeInput
    ): Promise<VehicleType> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.updateVehicleType,
                    variables: {
                        input
                    }
                })
            ).data.updateVehicleType;
            if (date) return date as VehicleType;
        } catch (error) {
            console.error('Error creating VehicleType:', error);
            return null;
        }
    }

    async deleteVehicleType(
        input: DeleteVehicleTypeInput
    ): Promise<VehicleType> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.deleteVehicleType,
                    variables: {
                        input
                    }
                })
            ).data.deleteVehicleType;
            if (data) return data as VehicleType;
        } catch (error) {
            console.error('Error deleting VehicleType:', error);
            return null;
        }
    }
}
